module.exports = __webpack_public_path__ + "static/img/exhibitFormTips6.46a082bb.png";